export const convertUnicode = str => {
  let res = str.replace(/\uf113/g, "김");
  res = res.replace(/\uf114/g, "일");
  res = res.replace(/\uf115/g, "성");
  res = res.replace(/\uf116/g, "김");
  res = res.replace(/\uf117/g, "정");
  res = res.replace(/\uf118/g, "일");
  res = res.replace(/\uf120/g, "김");
  res = res.replace(/\uf121/g, "정");
  res = res.replace(/\uf122/g, "은");
  return res;
};

export const processJonham = str => {
  if (!str) return "";
  let res = convertUnicode(str);
  res = res.replace(
    /김일성/g,
    `<label class="jonham"><strong style='font-size: 105%'>김일성</strong></label>`
  );
  res = res.replace(
    /김정일/g,
    `<label class="jonham"><strong style='font-size: 105%'>김정일</strong></label>`
  );
  res = res.replace(
    /김정은/g,
    `<label class="jonham"><strong style='font-size: 105%'>김정은</strong></label>`
  );
  res = res.replace(
    /Kim Il Sung/g,
    `<nobr><label class="jonham"><strong style='font-size: 105%'>Kim Il Sung</strong></label></nobr>`
  );
  res = res.replace(
    /Kim Jong Il/g,
    `<nobr><label class="jonham"><strong style='font-size: 105%'>Kim Jong Il</strong></label></nobr>`
  );
  res = res.replace(
    /Kim Jong Un/g,
    `<nobr><label class="jonham"><strong style='font-size: 105%'>Kim Jong Un</strong></label></nobr>`
  );
  return res;
};

export const isEmpty = value =>
  value === undefined ||
  value === null ||
  (typeof value === "object" && Object.keys(value).length === 0) ||
  (typeof value === "string" && value.trim().length === 0);

export default isEmpty;
